import { Component } from 'src/utils';
import newOrderImg from './../../../images/new-order.png';
import recentOrderImg from './../../../images/recent-order.png';
import favoriteImg from './../../../images/favorites.png';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import dscImg from './../../../images/DSC.png';
import subHeaderImg from './../../../images/banner-image.jpg';
import template from './category.html';
import logo from './../../../images/logo-s.png';
import dscCard from './../../../images/WBU-DSC-card.jpg';

@Component({
  controllerAs: 'category',
  template
})

export default class Category {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'authService',
    'orderService',
    '$interval',
      '$rootScope',
      '$timeout',
      '$stateParams',
      '$window',
      'APP',
      '$location','ngMeta' 
  ];

  constructor($scope, $ngRedux, $state, $auth, $order,$interval,$rootScope,$timeout, $stateParams, $window, APP, $location, ngMeta) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.newOrderImg = newOrderImg;
    this.recentOrderImg = recentOrderImg;
    this.favoriteImg = favoriteImg;
    this.dscImg = dscImg;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$auth = $auth;
    this.$order = $order;
    this.subHeaderImg = subHeaderImg;
    this.logo = logo;
    this.dscCard = dscCard;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.APP = APP;
    this.$location= $location;
    this.ngMeta = ngMeta;
    this.isMiscelleneousCategory = 4;
    if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '');
      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '')+'/' +this.$stateParams.storeName;
      
    } 
    else{
      this.canUrl = this.$location.$$absUrl;
    }
    // $order.getGiftCards();
    console.log("this.canUrl.category : ",this.canUrl);
    this.ngMeta.setTag('canUrl',this.canUrl);
    this.$interval = $interval;
    $rootScope.$on('rotateBanner', () => {
      console.log("Banner will rotate");
      this.promoSlider();
    });
    $rootScope.$on('rotateMobileBanner', () => {
      console.log("Mobile Banner will rotate - Code commented now. Will be used in next release");
      this.mobilePromoSlider();
    });
    this.$window.document.title = this.APP.ORDER.ORDER_URL.siteTitle;
    
    $scope.$on('$destroy', () => {
      this.$interval.cancel(this.promoSlideInterval);
      this.$interval.cancel(this.mobilePromoSlideInterval);
      disconnect();
    });
  }


  mapState(state) {
    return {
      profile: state.auth.profile,
      list: state.order.categories,
      giftCards : state.order.giftCards
    };
  }
  goToSavingsClub() {
    // this.closeSideNav();
    this.$state.go('savings-club', {'storeName': this.$auth.getGuestStoreDetail().storeName});

  }

  getCarousalSetting() {
    var carousalHeight = document.getElementById('carousel-item-bar').clientHeight;
    carousalHeight = 340;
    // console.log('carousalHeight',carousalHeight);
    this.settings ={};
    if (window.innerWidth < 1367 ) {
        var img =  2000 + "px " + carousalHeight + "px";
      this.settings = {"background-size" : img};
      return this.settings;
    }
    else {
     this.settings = {"background-size" : "2000px 340px"};
      return this.settings;
    }
    
  }
  getCarousalSettingMob() {
    var carousalHeight = document.getElementById('carousel-item-bar-mob').clientHeight;
    carousalHeight = 340;
    // console.log('carousalHeight',carousalHeight);
    this.settings ={};
    if (window.innerWidth < 1367 ) {
        var img =  2000 + "px " + carousalHeight + "px";
      this.settings = {"background-size" : img};
      return this.settings;
    }
    else {
     this.settings = {"background-size" : "2000px 340px"};
      return this.settings;
    }
    
  }
  goToNextState(item) {
    let storeName = '';
    if(this.$stateParams.storeName) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    // let storeName =  false;
    if (storeName) {
      if(this.isMiscellaneousCategory(item)){
        this.goToGiftPage(storeName);
      } else {
          if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1 ) {
            this.$state.go('browse-product', {
              categoryId: item.category.prettyUrl,
              subCategoryId: item.subCategoryList[0].prettyUrl,
              storeName:storeName
            });
          }
          else {
            this.$state.go('browse-sub-category', {categoryId: item.category.prettyUrl, storeName: storeName});
          } 
        }
    }
    else {
      if(this.isMiscellaneousCategory(item)){
        this.goToGiftPage(this.$auth.getGuestStoreDetail().storeName);
      } else {
        if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
          this.$state.go('browse-product', {
            categoryId: item.category.prettyUrl,
            subCategoryId: item.subCategoryList[0].prettyUrl,
            storeName: this.$auth.getGuestStoreDetail().storeName
          });
        } else {
          // console.log('sc',item.category.id);
          this.$state.go('browse-sub-category', {
            categoryId: item.category.prettyUrl , storeName: 'shop'
          });
        }
      }
    }
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  getBackgroundTitle(category) {
    if (category.alt) {
      return category.alt;
    }
    else {
      return 'Wild Birds Unlimited';
    }
  }

  getBackgroundStyle(category) {
    if (window.innerWidth < 544) {
      return category.smallImageUrl;
    }
    else if (window.innerWidth < 768) {
      return category.largeImageUrl;
    }
    else {
      return category.largeImageUrl;
    }
  }

  syncedToday() {
    let syncDate = new Date(this.profile.customer.lastSyncDateTime);
    let currentDate = new Date();
    return syncDate.getDate() === currentDate.getDate();
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }
  activePromo(activeindex) {
  if(this.$rootScope.promo) {
    this.$interval.cancel(this.promoSlideInterval);
    this.$rootScope.promo.promoImages.forEach((promo,index) => {
      // console.log(index);
      promo.active = false;
    // console.log(index);
    });
    this.$rootScope.promo.promoImages[activeindex].active = true;
    this.promoSlider();
  }
  }

  promoSlider() {
    if( this.$rootScope.promo) {
    return this.promoSlideInterval =  this.$interval(() => {
          var activeIndex = null;
    this.$rootScope.promo.promoImages.forEach((promo,index) => {
      if(promo.active) {
      activeIndex = index;
    }
  });
    var nextIndex = (this.$rootScope.promo.promoImages.length-1 == activeIndex) ? 0 : activeIndex + 1;
    this.$rootScope.promo.promoImages[activeIndex].active = false;
    this.$rootScope.promo.promoImages[nextIndex].active = true;

  },10000);
  } }


  activeMobilePromo(activeindex) {
    if(this.$rootScope.promo) {
      this.$interval.cancel(this.mobilePromoSlideInterval);
      this.$rootScope.promo.mobilePromoImages.forEach((promo,index) => {
        // console.log(index);
        promo.active = false;
      // console.log(index);
      });
      this.$rootScope.promo.mobilePromoImages[activeindex].active = true;
      this.mobilePromoSlider();
    }
    }


  isMobileDevice() {
    return this.$auth.isMobileLandscapeDevice();
  }
  mobilePromoSlider() {
    if( this.$rootScope.promo) {
      if(this.$rootScope.promo.mobilePromoImages!= null && this.$rootScope.promo.mobilePromoImages.length>0){
        return this.mobilePromoSlideInterval =  this.$interval(() => {
          var activeIndex = null;
            this.$rootScope.promo.mobilePromoImages.forEach((promo,index) => {
              if(promo.active) {
              activeIndex = index;
            }
          });
            var nextIndex = (this.$rootScope.promo.mobilePromoImages.length-1 == activeIndex) ? 0 : activeIndex + 1;
            this.$rootScope.promo.mobilePromoImages[activeIndex].active = false;
            this.$rootScope.promo.mobilePromoImages[nextIndex].active = true;
          },10000);
      }
    } 
  }
  
  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  isMiscellaneousCategory(item){
    if(item){
      if(item.category.id === this.isMiscelleneousCategory){
        return true;
      } else {
        return false;
      }
    }
  }

  goToGiftPage(store) {
    this.$state.go('gift-card', {'storeName': store});
  }
}



// WEBPACK FOOTER //
// ./src/app/order/category/category.js